import React from 'react';
import Header from '../shared/header/Header';
import Hero from '../hero/Hero';
import About from '../about/About';
import Portfolio from '../portfolio/Portfolio';
import Contact from '../contact/Contact';
import Footer from '../footer/Footer';
import './Home.css';

function Home() {

  return (
    <div className="home">
      <Header />
      
      <Hero />
      
      <About />
      
      <Portfolio />
      
      <Contact />
      
      <Footer />
    </div>
  );
}

export default Home;
